import React, {Component} from "react";

const stadiaLogo = require("../../resources/img/anywhere/stadia_logo.svg");

export default class StadiaCard extends Component {
    render(): JSX.Element {
        return (
            <div className="anywhereTab__cards__card stadia">

                <img src={stadiaLogo} alt="Stadia Logo" />

                <h2>Ubisoft+ is coming to Stadia soon</h2>

                <button className="btn btn__disabled" tabIndex={-1}>Coming soon</button>
            </div>
        );
    }
}